module.exports = __webpack_public_path__ + "static/005-9ad305e1843b0b22afe0cef4e229221d.png";